import { Component, Input, OnInit } from '@angular/core';
import { DynamicItem } from 'src/app/main/dynamic/dynamic-item';

@Component({
  selector: 'app-default',
  template: `<app-dynamic *ngFor="let attribute of attribute.attributes"
              [attribute]="attribute"
              [envOptions]="envOptions"
              (onEmit)="emitEvents($event)">
            </app-dynamic>`
})
export class DefaultComponent extends DynamicItem implements OnInit {

  @Input() cssClass: string

  constructor() {
    super()
  }

  ngOnInit() {
  }
}
